<div ngbDropdown class="vox-dropdown-input">
  <button type="button" ngbDropdownToggle>{{'integrations.filters.status.' + selectedIntegrationStatus | translate}}</button>
  <div ngbDropdownMenu>
    <button type="button" ngbDropdownItem *ngFor="let value of INTEGRATION_STATUS"
      (click)="selectIntegrationStatus(value)">{{'integrations.filters.status.' + value | translate}}</button>
  </div>
</div>